/* global System */
// register component(s) with react habitat

export default {
  ImageComponent: () =>
    System.import(
      /* webpackChunkName: "ImageComponent" */
      './index'
    ),
}
